import React from "react";
import { FaFilePdf, FaFileVideo, FaMusic } from "react-icons/fa";

export default function HeroSection() {
  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      console.log("Tanlangan fayl:", file.name);
    }
  };

  return (
    <main className="bg-[#ffffff]">
      <div className="max-w-4xl mx-auto px-4 pt-20 pb-20 text-center">
        {/* === TITLE === */}
        <h1 className="text-[42px] sm:text-[52px] md:text-[64px] font-bold leading-[1.1] text-gray-900 tracking-[-0.02em]">
          Sun&apos;iy intellekt yordamida
          <br />
          testlar yarating
        </h1>

        {/* === SUBTITLE === */}
        <p className="mt-6 text-[15px] sm:text-[17px] md:text-[18px] leading-relaxed text-gray-500 max-w-2xl mx-auto">
          Har qanday hujjat, pdf faylni yuklang va bir necha
          daqiqada tayyor testga ega bo&apos;ling. Tez, oson, samarali.
        </p>

        {/* === UPLOAD CARD === */}
        <div className="mt-12 w-full max-w-3xl mx-auto rounded-[32px] border-2 border-dashed border-gray-300 bg-white px-6 sm:px-10 py-8 sm:py-10 shadow-sm">
          {/* ICON */}
          {/* ICON */}
          <div className="flex justify-center">
            <div className="relative animate-uploadPulse">
              {/* TASHQI ENG KATTA HALQA */}
              <div className="h-20 w-20 rounded-full bg-[#e5e5e5] flex items-center justify-center">
                {/* O'RTADAGI KULRANG HALQA */}
                <div className="h-16 w-16 rounded-full bg-[#c3c3c3] flex items-center justify-center">
                  {/* ICHKARIDAGI QORA DOIRA */}
                  <div className="h-10 w-10 rounded-full bg-[#111111] flex items-center justify-center shadow-md">
                    {/* upload strelka — svg */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 text-white"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M16 8l-4-4m0 0L8 8m4-4v12"
                      />
                    </svg>
                  </div>
                </div>
              </div>

              {/* YONIDAGI YULDUZCHA */}
              <div className="absolute -top-1 -right-2 h-5 w-5 rounded-full  flex items-center justify-center">
               {/* YULDUZCHA */}



              </div>
            </div>
          </div>



          {/* MATN + INPUT */}
          <label
            htmlFor="file-upload"
            className="mt-6 block cursor-pointer text-center"
          >
            <p className="text-base sm:text-lg md:text-xl font-semibold text-gray-900">
              Faylni bu yerga sudrab oling yoki tanlash uchun bosing
            </p>

            <p className="mt-2 text-xs sm:text-sm text-gray-500">
              Maksimal fayl hajmi: 3GB
            </p>

            <div className="mt-3 flex justify-center">
              <span className="inline-flex items-center rounded-full bg-[#ffe8b5] text-[#c98a22] px-4 py-1 text-xs sm:text-sm font-medium">
                Yuklash uchun hisob kerak
              </span>
            </div>

            <input
              id="file-upload"
              type="file"
              className="hidden"
              onChange={handleFileChange}
            />
          </label>

          {/* === FAYL TURLARI === */}
          <div className="mt-8 flex flex-wrap justify-center gap-4 sm:gap-6 text-xs sm:text-sm">
            {/* PDF, DOCX */}
            <div className="flex flex-col items-center gap-2">
              <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-[#ffe1e1]">
                <FaFilePdf className="h-6 w-6 text-[#e53935]" />
              </div>
              <span className="text-gray-900 text-[11px] sm:text-xs">
                PDF, DOCX
              </span>
            </div>

        
          </div>
        </div>

        {/* === PASTDAGI INFO PUNKTlar === */}
        <div className="mt-10 flex flex-wrap justify-center gap-6 text-[13px] sm:text-[14px] text-gray-600">
          <div className="flex items-center gap-2">
            <span className="h-2 w-2 rounded-full bg-green-500"></span>
            AI asosida
          </div>

          <div className="flex items-center gap-2">
            <span className="h-2 w-2 rounded-full bg-blue-500"></span>
            O‘zbek tili qo‘llab-quvvatlanadi
          </div>

          <div className="flex items-center gap-2">
            <span className="h-2 w-2 rounded-full bg-purple-500"></span>
            Tezkor natijalar
          </div>
        </div>
      </div>
    </main>
  );
}
